import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/system/security/events')({ component: Outlet })
